module.exports = __webpack_public_path__ + "img/img03.c5c5c86e.png";